import { useAppSelector } from "../../../app/store";
import UserImg from "../../../assets/images/avatar.svg";
import InfoItem from "../../../components/common/InfoItem";
import CustomEmpty from "../../../components/ui/CustomEmpty";
import Loader from "../../../components/ui/Loader";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatDate, formatTime } from "../../../lib/time";
import NotFound from "../../NotFound";
import {
  ComponentDetails,
  useEmployeeProfile,
} from "../Employees/EmployeesDetails";

export default function EmployeeDashboard() {
  const { authInfo } = useAppSelector((state) => state.auth);
  const {
    error,
    isLoading,
    employeeDetails,
    employeeDetailsList,
    setItem,
    setSearchParams,
    item,
    isAdditionalLoading,
    additionalData,
    getInfoData,
    isComponentSettingLoading,
    componentDetails,
    isSalaryLoading,
    salaryData,
  } = useEmployeeProfile(String(authInfo?.id));
  if (error && "status" in error && error.status === 404) {
    return <NotFound title="Sorry, data not found" />;
  }

  return (
    <SidebarLayout title="Profile">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="bg-white rounded-md grid md:grid-cols-4">
            <ul className="p-4 border-r border-extra-light">
              <li className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14">
                  <img
                    className="w-full h-full rounded-full object-cover"
                    src={employeeDetails?.member?.profile?.pro_pic || UserImg}
                    alt=""
                  />
                </div>
                <div className="flex flex-col gap-0.5">
                  <h3 className="text-body text-lg font-semibold leading-normal">
                    {employeeDetails?.member?.profile?.name}
                  </h3>

                  <p className="text-body-text text-sm font-medium leading-normal">
                    {employeeDetails?.role?.name}
                  </p>
                </div>
              </li>

              {employeeDetailsList?.map((el) => (
                <li
                  key={el}
                  onClick={() => {
                    setItem(el);
                    setSearchParams({ type: el });
                  }}
                  className={`font-medium h-10 px-3 rounded-lg flex items-center cursor-pointer ${
                    el === item ? "bg-[#fff1eb]/50 text-primary" : "text-muted"
                  }`}
                >
                  {el}
                </li>
              ))}
              {isAdditionalLoading ? (
                <li className="text-center py-1 text-body">Loading...</li>
              ) : (
                additionalData?.data?.additionalSections?.map((el, index) => (
                  <li
                    key={el?.id}
                    onClick={() => {
                      setItem(el?.id);
                      setSearchParams({ type: el?.id?.toString() });
                    }}
                    className={`font-medium h-10 px-3 rounded-lg flex items-center cursor-pointer ${
                      item?.toString() === el?.id?.toString()
                        ? "bg-[#fff1eb]/50 text-primary"
                        : "text-muted"
                    }`}
                  >
                    {el?.label}
                  </li>
                ))
              )}
            </ul>
            <div className="md:col-span-3 p-4">
              {getInfoData()}
            </div>
          </div>
          {item !== "Salary" ? null : isComponentSettingLoading ? (
            <div className="py-4">
              <Loader />
            </div>
          ) : !componentDetails?.addition?.length &&
            !componentDetails?.deduction?.length ? null : (
            <div className="bg-white rounded-md mt-6 p-4">
              <div className="grid sm:grid-cols-2 gap-10">
                <div>
                  <h5 className="text-header font-semibold text-xl mb-3">
                    Addition Details
                  </h5>
                  {componentDetails?.addition?.length ? (
                    componentDetails?.addition?.map((item, idx) => (
                      <ComponentDetails
                        item={item}
                        index={idx}
                        key={item?.id}
                      />
                    ))
                  ) : (
                    <div>
                      <CustomEmpty rootClassName="py-20" />
                    </div>
                  )}
                </div>
                <div>
                  <h5 className="text-header font-semibold text-xl mb-3">
                    Deduction Details
                  </h5>
                  {componentDetails?.deduction?.length ? (
                    componentDetails?.deduction?.map((item, idx) => (
                      <ComponentDetails
                        item={item}
                        index={idx}
                        key={item?.id}
                      />
                    ))
                  ) : (
                    <div>
                      <CustomEmpty rootClassName="py-20" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {item !== "Salary" ? null : isSalaryLoading ? (
            <div className="py-4">
              <Loader />
            </div>
          ) : salaryData?.data?.salary_info?.gross_salary_log?.length ? (
            <div className="bg-white rounded-md mt-6 p-4 pb-0">
              <h5 className="text-header font-semibold text-xl mb-3">
                Salary Logs
              </h5>
              <ul>
                {salaryData?.data?.salary_info?.gross_salary_log?.map((log) => (
                  <InfoItem
                    title={`${formatTime(log?.created_at)} - ${formatDate(
                      log?.created_at
                    )}`}
                    key={log?.id}
                  >
                    {log?.log}
                  </InfoItem>
                ))}
              </ul>
            </div>
          ) : null}
        </>
      )}
    </SidebarLayout>
  );
}
